import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import TrophyProp from '../../../journey/propTypes/trophyProp';
import Anchor from '../../../../commonComponents/Anchor';
import { displayUserName } from '../../../../services/utilityFunctions';

export default function TrophyModalItem({ t, trophy }) {
  const { name, url, description } = useMemo(() => {
    const isGame = !!trophy?.game;
    const isJourney = !!trophy?.journey;
    const isCourse = !!trophy?.course;
    const isManager = !!trophy?.manager;
    const isMarketCommissionReport = !!trophy?.marketCommissionReport;
    let defaultName = '';
    let defaultUrl = null;
    let defaultDescription = '';

    if (isGame) {
      defaultName = trophy?.game?.name;
      defaultUrl = `/challenges/${trophy?.game?._id}/leaderboard`;
      defaultDescription = trophy?.game?.summary;
    }

    if (isJourney) {
      defaultName = trophy?.journey?.title;
      defaultUrl = `/journey/${trophy?.journey?._id}`;
      defaultDescription = trophy?.journey?.summary;
    }

    if (isCourse) {
      defaultName = trophy?.course?.name;
      defaultUrl = `/courses/${trophy?.course?._id}`;
      defaultDescription = trophy?.course?.summary;
    }
    if (isManager) {
      defaultName = displayUserName(trophy?.manager);
      defaultUrl = null;
      defaultDescription = trophy?.message || '';
    }

    if (isMarketCommissionReport) {
      defaultName = t('market.commission.report');
      defaultUrl = null;
      defaultDescription = `${trophy?.marketCommissionReport?.month}/${trophy?.marketCommissionReport?.year}`;
    }

    const descriptionValue =
      trophy?.value > 0
        ? `${trophy.value}${trophy?.unity ? ` ${trophy?.unity}` : ''}`
        : defaultDescription;

    return {
      name: defaultName,
      url: defaultUrl,
      description: descriptionValue,
    };
  }, [trophy]);

  return (
    <div className="m-timeline-3__item m-timeline-3__item--dynamic">
      <span className="m-timeline-3__item-time">
        {moment(trophy.date).format('HH:mm')}
        <br />
        {moment(trophy.date).format('DD MMM, YY')}
      </span>
      <div className="m-timeline-3__item-desc">
        <span className="m-timeline-3__item-user-name">
          <Anchor
            href={url}
            className="m-link m-link--metal m-timeline-3__item-link"
          >
            {name}
          </Anchor>
        </span>
        <br />
        <span className="m-timeline-3__item-text">{description}</span>
      </div>
    </div>
  );
}

TrophyModalItem.propTypes = {
  t: PropTypes.func.isRequired,
  trophy: PropTypes.shape(TrophyProp.propType).isRequired,
};
